import React from 'react'

import { publishEvent } from '@zet/analytics'
import { useToast } from '@zet/common/components/toast'
import { AgentDetails } from '@zet/customer'
import { B2, Button, H4, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import NoAccess from '../../../../../customer/assets/svgs/noAccess.svg'
import { useGetNextStateForProductFlow } from '../../../../api/brands/hooks'
import { BottomsheetTypes } from '../../../../api/brands/types'
import { useProductFlowApply } from '../../../../hooks/useProductFlowApply'

const DontHaveAccesstoNumbers = ({
  agentData,
  handleBottomsheetState,
}: {
  agentData: AgentDetails
  handleBottomsheetState: (state: BottomsheetTypes) => void
}) => {
  const { mutate, isLoading } = useGetNextStateForProductFlow()
  const toast = useToast()
  const { apply, shareLinkLoading } = useProductFlowApply(
    agentData,
    handleBottomsheetState
  )

  const handleSubmit = () => {
    publishEvent('click_action', {
      item_name: 'shortflow_secondary_phone_number_ntc',
    })
    mutate(
      {
        customerPayload: {
          secondaryPhoneNumber: null,
          customerId: sessionStorage.getItem('customerId'),
        },
        userState: 'SHOWN_SECONDARY_PHONE_NUMBER_SCREEN_V3',
      },
      {
        onSuccess(data) {
          if (data?.action === 'SHOW_PAN_COLLECTION_SCREEN_V3') {
            handleBottomsheetState('BASIC_DETAILS')
          } else if (data?.action === 'SHOW_BASIC_DETAILS_SCREEN_V3') {
            handleBottomsheetState('EMPLOYMENT_DETAILS')
          } else if (data?.action === 'SHOW_RECOMMENDATION_SCREEN') {
            apply()
          }
        },
        onError(err) {
          toast?.show({
            intent: 'error',
            heading: i18n.t('toastMessages.error'),
            description:
              err?.response?.data?.error?.message ||
              i18n.t('toastMessages.somethingWentWrong'),
            hideAfter: 3000,
          })
        },
      }
    )
  }

  const goBack = () => {
    mutate(
      {
        customerPayload: {
          customerId: sessionStorage.getItem('customerId'),
        },
        userState: 'BACK',
      },
      {
        onSuccess(data) {
          handleBottomsheetState('SECONDARY_PHONE_NUMBERS')
        },
      }
    )
  }

  return (
    <>
      <Stack className="h-[450px] items-center justify-center px-7 pt-3">
        <Stack>
          <NoAccess width={80} height={90} />
        </Stack>
        <H4 className="text-grays-100 text-center font-[Graphie-Bold]">
          {i18n.t('verifySecondaryPhoneNumber.youDontHaveAccesToNumbers')}
        </H4>
        <B2 className="text-grays-60 mt-2 text-center">
          {i18n.t('verifySecondaryPhoneNumber.pleaseNote')}
        </B2>
      </Stack>
      <Stack className="bg-neutral-white100 absolute bottom-0 w-full px-3 py-2">
        <Button
          size={'lg'}
          className={'bg-tertiary-200 w-full'}
          textStyle="text-base"
          onPress={handleSubmit}
          loading={isLoading || shareLinkLoading}
        >
          {i18n.t('verifySecondaryPhoneNumber.yesSure')}
        </Button>
        <Button
          size={'lg'}
          outlined
          className={
            'border-tertiary-200 my-2 w-full  bg-white hover:border-black hover:bg-[rgba(0,0,0,0.1)] focus:bg-[rgba(0,0,0,0.1)] active:border-black active:bg-[rgba(0,0,0,0.1)]'
          }
          opacity={false}
          textStyle="text-tertiary-100 text-base"
          onPress={goBack}
          loading={isLoading || shareLinkLoading}
        >
          {i18n.t('verifySecondaryPhoneNumber.noBack')}
        </Button>
      </Stack>
    </>
  )
}

export default DontHaveAccesstoNumbers
